module.exports = __webpack_public_path__ + "img/9788963706849.d735b522.jpg";